declare namespace $ {

	type $shm_mentionstat_form__query_shm_mentionstat_task_1 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_query'] >
		,
		ReturnType< $shm_mentionstat_form['query'] >
	>
	type $shm_mentionstat_form__excluded_words_shm_mentionstat_task_2 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_excluded_words'] >
		,
		ReturnType< $shm_mentionstat_form['excluded_words'] >
	>
	type $shm_mentionstat_form__date_from_shm_mentionstat_task_3 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_date_from'] >
		,
		ReturnType< $shm_mentionstat_form['date_from'] >
	>
	type $shm_mentionstat_form__date_to_shm_mentionstat_task_4 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_date_to'] >
		,
		ReturnType< $shm_mentionstat_form['date_to'] >
	>
	type $shm_mentionstat_form__country_shm_mentionstat_task_5 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_country'] >
		,
		ReturnType< $shm_mentionstat_form['country'] >
	>
	type $shm_mentionstat_form__language_shm_mentionstat_task_6 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_language'] >
		,
		ReturnType< $shm_mentionstat_form['language'] >
	>
	type $shm_mentionstat_form__search_type_shm_mentionstat_task_7 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_search_type'] >
		,
		ReturnType< $shm_mentionstat_form['search_type'] >
	>
	type $shm_mentionstat_form__tags_shm_mentionstat_task_8 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_tags'] >
		,
		ReturnType< $shm_mentionstat_form['tags'] >
	>
	type $shm_mentionstat_form__category_shm_mentionstat_task_9 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_category'] >
		,
		ReturnType< $shm_mentionstat_form['category'] >
	>
	type $shm_mentionstat_form__social_files_shm_mentionstat_task_10 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_social_files'] >
		,
		ReturnType< $shm_mentionstat_form['social_files'] >
	>
	type $shm_mentionstat_form__mass_files_shm_mentionstat_task_11 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_mass_files'] >
		,
		ReturnType< $shm_mentionstat_form['mass_files'] >
	>
	type $shm_mentionstat_form__social_existing_title_shm_mentionstat_task_12 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_social_existing_title'] >
		,
		ReturnType< $shm_mentionstat_form['social_existing_title'] >
	>
	type $shm_mentionstat_form__mass_existing_title_shm_mentionstat_task_13 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_mass_existing_title'] >
		,
		ReturnType< $shm_mentionstat_form['mass_existing_title'] >
	>
	type $shm_mentionstat_form__submit_title_shm_mentionstat_task_14 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_submit_title'] >
		,
		ReturnType< $shm_mentionstat_form['submit_title'] >
	>
	type $shm_mentionstat_form__submit_shm_mentionstat_task_15 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_submit'] >
		,
		ReturnType< $shm_mentionstat_form['submit'] >
	>
	type $shm_mentionstat_form__reset_shm_mentionstat_task_16 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['form_reset'] >
		,
		ReturnType< $shm_mentionstat_form['reset'] >
	>
	type $mol_view__sub_shm_mentionstat_task_17 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['result_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_content_shm_mentionstat_task_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__tools_shm_mentionstat_task_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_mentionstat_task_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_mentionstat_items__item_ids_shm_mentionstat_task_21 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_ids'] >
		,
		ReturnType< $shm_mentionstat_items['item_ids'] >
	>
	type $shm_mentionstat_items__item_query_shm_mentionstat_task_22 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_query'] >
		,
		ReturnType< $shm_mentionstat_items['item_query'] >
	>
	type $shm_mentionstat_items__item_excluded_shm_mentionstat_task_23 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_excluded'] >
		,
		ReturnType< $shm_mentionstat_items['item_excluded'] >
	>
	type $shm_mentionstat_items__item_period_shm_mentionstat_task_24 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_period'] >
		,
		ReturnType< $shm_mentionstat_items['item_period'] >
	>
	type $shm_mentionstat_items__item_country_shm_mentionstat_task_25 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_country'] >
		,
		ReturnType< $shm_mentionstat_items['item_country'] >
	>
	type $shm_mentionstat_items__item_language_shm_mentionstat_task_26 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_language'] >
		,
		ReturnType< $shm_mentionstat_items['item_language'] >
	>
	type $shm_mentionstat_items__item_social_shm_mentionstat_task_27 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_social'] >
		,
		ReturnType< $shm_mentionstat_items['item_social'] >
	>
	type $shm_mentionstat_items__item_mass_shm_mentionstat_task_28 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_mass'] >
		,
		ReturnType< $shm_mentionstat_items['item_mass'] >
	>
	type $shm_mentionstat_items__item_type_shm_mentionstat_task_29 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_type'] >
		,
		ReturnType< $shm_mentionstat_items['item_type'] >
	>
	type $shm_mentionstat_items__item_tags_shm_mentionstat_task_30 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_tags'] >
		,
		ReturnType< $shm_mentionstat_items['item_tags'] >
	>
	type $shm_mentionstat_items__item_category_shm_mentionstat_task_31 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_category'] >
		,
		ReturnType< $shm_mentionstat_items['item_category'] >
	>
	type $shm_mentionstat_items__item_edit_shm_mentionstat_task_32 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_edit'] >
		,
		ReturnType< $shm_mentionstat_items['item_edit'] >
	>
	type $shm_mentionstat_items__item_delete_shm_mentionstat_task_33 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['item_delete'] >
		,
		ReturnType< $shm_mentionstat_items['item_delete'] >
	>
	type $shm_mentionstat_items__merge_title_shm_mentionstat_task_34 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['merge_title'] >
		,
		ReturnType< $shm_mentionstat_items['merge_title'] >
	>
	type $shm_mentionstat_items__merge_enabled_shm_mentionstat_task_35 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['merge_enabled'] >
		,
		ReturnType< $shm_mentionstat_items['merge_enabled'] >
	>
	type $shm_mentionstat_items__merge_start_shm_mentionstat_task_36 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['merge_start'] >
		,
		ReturnType< $shm_mentionstat_items['merge_start'] >
	>
	type $shm_mentionstat_items__status_text_shm_mentionstat_task_37 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['status_text'] >
		,
		ReturnType< $shm_mentionstat_items['status_text'] >
	>
	type $shm_mentionstat_items__status_color_shm_mentionstat_task_38 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['status_color'] >
		,
		ReturnType< $shm_mentionstat_items['status_color'] >
	>
	type $mol_page__title_content_shm_mentionstat_task_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__tools_shm_mentionstat_task_40 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['report_tools'] >
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_mentionstat_task_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_mentionstat_chart__rows_shm_mentionstat_task_42 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['chart_rows'] >
		,
		ReturnType< $shm_mentionstat_chart['rows'] >
	>
	type $shm_mentionstat_chart__group_shm_mentionstat_task_43 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['chart_group'] >
		,
		ReturnType< $shm_mentionstat_chart['group'] >
	>
	type $shm_mentionstat_chart__total_visible_shm_mentionstat_task_44 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['chart_total_visible'] >
		,
		ReturnType< $shm_mentionstat_chart['total_visible'] >
	>
	type $shm_wordstat_table__table_shm_mentionstat_task_45 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['query_table'] >
		,
		ReturnType< $shm_wordstat_table['table'] >
	>
	type $mol_view__sub_shm_mentionstat_task_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_download__title_shm_mentionstat_task_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__blob_shm_mentionstat_task_48 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['csv_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__file_name_shm_mentionstat_task_49 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['csv_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $shm_mentionstat_filter_panel__total_visible_shm_mentionstat_task_50 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['chart_total_visible'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['total_visible'] >
	>
	type $shm_mentionstat_filter_panel__date_from_shm_mentionstat_task_51 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['filter_date_from'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['date_from'] >
	>
	type $shm_mentionstat_filter_panel__date_to_shm_mentionstat_task_52 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['filter_date_to'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['date_to'] >
	>
	type $shm_mentionstat_filter_panel__query_values_shm_mentionstat_task_53 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['query_values'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['query_values'] >
	>
	type $shm_mentionstat_filter_panel__query_all_shm_mentionstat_task_54 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['query_all'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['query_all'] >
	>
	type $shm_mentionstat_filter_panel__query_checked_shm_mentionstat_task_55 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['query_checked'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['query_checked'] >
	>
	type $shm_mentionstat_filter_panel__query_only_shm_mentionstat_task_56 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['query_only'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['query_only'] >
	>
	type $shm_mentionstat_filter_panel__scope_values_shm_mentionstat_task_57 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['scope_values'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['scope_values'] >
	>
	type $shm_mentionstat_filter_panel__scope_all_shm_mentionstat_task_58 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['scope_all'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['scope_all'] >
	>
	type $shm_mentionstat_filter_panel__scope_checked_shm_mentionstat_task_59 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['scope_checked'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['scope_checked'] >
	>
	type $shm_mentionstat_filter_panel__scope_only_shm_mentionstat_task_60 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['scope_only'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['scope_only'] >
	>
	type $shm_mentionstat_filter_panel__country_values_shm_mentionstat_task_61 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['country_values'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['country_values'] >
	>
	type $shm_mentionstat_filter_panel__country_all_shm_mentionstat_task_62 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['country_all'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['country_all'] >
	>
	type $shm_mentionstat_filter_panel__country_checked_shm_mentionstat_task_63 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['country_checked'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['country_checked'] >
	>
	type $shm_mentionstat_filter_panel__country_only_shm_mentionstat_task_64 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['country_only'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['country_only'] >
	>
	type $shm_mentionstat_filter_panel__language_values_shm_mentionstat_task_65 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['language_values'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['language_values'] >
	>
	type $shm_mentionstat_filter_panel__language_all_shm_mentionstat_task_66 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['language_all'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['language_all'] >
	>
	type $shm_mentionstat_filter_panel__language_checked_shm_mentionstat_task_67 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['language_checked'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['language_checked'] >
	>
	type $shm_mentionstat_filter_panel__language_only_shm_mentionstat_task_68 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['language_only'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['language_only'] >
	>
	type $shm_mentionstat_filter_panel__type_values_shm_mentionstat_task_69 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['type_values'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['type_values'] >
	>
	type $shm_mentionstat_filter_panel__type_all_shm_mentionstat_task_70 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['type_all'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['type_all'] >
	>
	type $shm_mentionstat_filter_panel__type_checked_shm_mentionstat_task_71 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['type_checked'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['type_checked'] >
	>
	type $shm_mentionstat_filter_panel__type_only_shm_mentionstat_task_72 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['type_only'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['type_only'] >
	>
	type $shm_mentionstat_filter_panel__category_values_shm_mentionstat_task_73 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['category_values'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['category_values'] >
	>
	type $shm_mentionstat_filter_panel__category_all_shm_mentionstat_task_74 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['category_all'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['category_all'] >
	>
	type $shm_mentionstat_filter_panel__category_checked_shm_mentionstat_task_75 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['category_checked'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['category_checked'] >
	>
	type $shm_mentionstat_filter_panel__category_only_shm_mentionstat_task_76 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['category_only'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['category_only'] >
	>
	type $shm_mentionstat_filter_panel__reset_shm_mentionstat_task_77 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['filters_reset'] >
		,
		ReturnType< $shm_mentionstat_filter_panel['reset'] >
	>
	type $shm_service_dashboard_head__title_shm_mentionstat_task_78 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['task_title_draft'] >
		,
		ReturnType< $shm_service_dashboard_head['title'] >
	>
	type $shm_service_dashboard_head__title_save_shm_mentionstat_task_79 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['task_title_save'] >
		,
		ReturnType< $shm_service_dashboard_head['title_save'] >
	>
	type $shm_service_dashboard_head__menu_shm_mentionstat_task_80 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['Settings'] >
		,
		ReturnType< $shm_service_dashboard_head['menu'] >
	>
	type $shm_service_dashboard_head__edit_shm_mentionstat_task_81 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['mode_edit'] >
		,
		ReturnType< $shm_service_dashboard_head['edit'] >
	>
	type $shm_service_dashboard_head__view_shm_mentionstat_task_82 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['mode_view'] >
		,
		ReturnType< $shm_service_dashboard_head['view'] >
	>
	type $shm_service_dashboard_head__view_visible_shm_mentionstat_task_83 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['mode_view_enabled'] >
		,
		ReturnType< $shm_service_dashboard_head['view_visible'] >
	>
	type $shm_service_dashboard_head__view_enabled_shm_mentionstat_task_84 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['mode_view_enabled'] >
		,
		ReturnType< $shm_service_dashboard_head['view_enabled'] >
	>
	type $shm_service_dashboard_head__edit_color_shm_mentionstat_task_85 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['mode_edit_color'] >
		,
		ReturnType< $shm_service_dashboard_head['edit_color'] >
	>
	type $shm_service_dashboard_head__view_color_shm_mentionstat_task_86 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['mode_view_color'] >
		,
		ReturnType< $shm_service_dashboard_head['view_color'] >
	>
	type $shm_service_task_menu__remove_shm_mentionstat_task_87 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_task['task_delete'] >
		,
		ReturnType< $shm_service_task_menu['remove'] >
	>
	export class $shm_mentionstat_task extends $shm_service_dashboard {
		task_pages( ): readonly(any)[]
		form_query( next?: string ): string
		form_excluded_words( next?: string ): string
		form_date_from( next?: string ): string
		form_date_to( next?: string ): string
		form_country( next?: string ): string
		form_language( next?: string ): string
		form_search_type( next?: string ): string
		form_tags( next?: string ): string
		form_category( next?: string ): string
		form_social_files( next?: readonly(File)[] ): readonly(File)[]
		form_mass_files( next?: readonly(File)[] ): readonly(File)[]
		form_social_existing_title( ): string
		form_mass_existing_title( ): string
		form_submit( next?: any ): any
		form_reset( next?: any ): any
		Form( ): $shm_mentionstat_form
		item_query( id: any): string
		item_excluded( id: any): string
		item_period( id: any): string
		item_country( id: any): string
		item_language( id: any): string
		item_social( id: any): string
		item_mass( id: any): string
		item_type( id: any): string
		item_tags( id: any): string
		item_category( id: any): string
		item_edit( id: any, next?: any ): any
		item_delete( id: any, next?: any ): any
		merge_start( next?: any ): any
		report_tools( ): readonly(any)[]
		Result( ): $mol_view
		chart_group( next?: string ): string
		chart_total_visible( next?: boolean ): boolean
		csv_blob( ): any
		csv_file_name( ): string
		filter_date_from( next?: string ): string
		filter_date_to( next?: string ): string
		query_all( next?: boolean ): boolean
		query_checked( id: any, next?: boolean ): boolean
		query_only( id: any, next?: any ): any
		scope_all( next?: boolean ): boolean
		scope_checked( id: any, next?: boolean ): boolean
		scope_only( id: any, next?: any ): any
		country_all( next?: boolean ): boolean
		country_checked( id: any, next?: boolean ): boolean
		country_only( id: any, next?: any ): any
		language_all( next?: boolean ): boolean
		language_checked( id: any, next?: boolean ): boolean
		language_only( id: any, next?: any ): any
		type_all( next?: boolean ): boolean
		type_checked( id: any, next?: boolean ): boolean
		type_only( id: any, next?: any ): any
		category_all( next?: boolean ): boolean
		category_checked( id: any, next?: boolean ): boolean
		category_only( id: any, next?: any ): any
		filters_reset( next?: any ): any
		task_title_draft( next?: string ): string
		task_title_save( next?: any ): any
		mode_edit( next?: any ): any
		mode_view( next?: any ): any
		mode_edit_color( ): string
		mode_view_color( ): string
		task_delete( next?: any ): any
		task_id( ): string
		task_title( ): string
		task_mode( ): string
		pages( ): ReturnType< $shm_mentionstat_task['task_pages'] >
		form_submit_title( ): string
		Edit_page( ): $mol_page
		item_ids( ): readonly(any)[]
		merge_title( ): string
		merge_enabled( ): boolean
		status_text( ): string
		status_color( ): string
		Items_page( ): $shm_mentionstat_items
		result_rows( ): readonly(any)[]
		query_table( ): any
		chart_rows( ): readonly(any)[]
		Report_page( ): $mol_page
		Chart( ): $shm_mentionstat_chart
		Table( ): $shm_wordstat_table
		Empty( ): $mol_view
		Csv_download( ): $mol_button_download
		query_values( ): readonly(any)[]
		scope_values( ): readonly(any)[]
		country_values( ): readonly(any)[]
		language_values( ): readonly(any)[]
		type_values( ): readonly(any)[]
		category_values( ): readonly(any)[]
		filter_reset( next?: any ): any
		Filters_page( ): $shm_mentionstat_filter_panel
		Dashboard_head( ): $shm_service_dashboard_head
		Settings( ): $shm_service_task_menu
		mode_view_enabled( ): boolean
	}
	
}

//# sourceMappingURL=task.view.tree.d.ts.map